export default "__VITE_ASSET__72483fe5__"